import 'fomantic-ui-less/definitions/behaviors/form';

import 'fomantic-ui-less/definitions/modules/popup.less';
import 'fomantic-ui-less/definitions/modules/popup';
import {friendlyBytes} from '../helper/file';
import {handleClick, handleDelete} from '../helper/dom';

export default class LinkMarkView {
    constructor(mark, view, inline) {
        this.view = view;
        this.inline = inline;
        this.mark = mark;

        if (!mark.attrs['data-id']) {
            this.dom = document.createElement('a');
            this.dom.href = mark.attrs.href;
            this.dom.rel = 'noopener noreferrer';
            if (mark.attrs.title) {
                this.dom.title = mark.attrs.title;
            }
            if (mark.attrs.button) {
              this.dom.className = 'ui button compact';

              if (mark.attrs.color) {
                this.dom.className =  `${this.dom.className} ${mark.attrs.color}`;
              }

              this.dom.addEventListener('click', e => handleClick(view, this.dom, view.state.schema.marks.link));
            }
        } else {
            const link = document.createElement('a');
            link.href = mark.attrs.href;
            link.rel = 'noopener noreferrer';
            link.addEventListener('click', e => handleClick(view, link, view.state.schema.marks.link));

            if (mark.attrs['data-id']) {
                link.setAttribute('data-id', mark.attrs['data-id'] || '');
            }

            if (mark.attrs.title) {
                link.title = mark.attrs.title;
            }

            if (mark.attrs['data-size']) {
                link.setAttribute('data-size', mark.attrs['data-size'] || '');
            }

            if (mark.attrs['data-type']) {
                link.setAttribute('data-type', mark.attrs['data-type'] || '');
            }

            const paperclip = document.createElement('i');
            paperclip.className = 'paperclip icon';
            paperclip.contentEditable = 'false';
            paperclip.addEventListener('click', e => handleClick(view, link, view.state.schema.marks.link));

            const close = document.createElement('i');
            close.className = 'delete icon';
            close.contentEditable = 'false';
            close.addEventListener('click', e => handleDelete(view, link, view.state.schema.marks.link));

            const label = document.createElement('div');
            label.className = `ui label large attachment basic${mark.attrs.error ? ' red' : ''}`;
            label.appendChild(paperclip);
            label.appendChild(link);
            label.appendChild(close);

            $(label).popup({
                variation: 'mini',
                title: mark.attrs.title || '',
                content: friendlyBytes(mark.attrs['data-size']),
                transition: 'scale',
                duration: 0,
            });

            this.dom = label;
            this.contentDOM = link;
        }
    }
}